import { makeStyles } from '@material-ui/core/styles';
import { getMagnoliaUrlImage } from '../../helpers/AppHelpers';
import { ImageType } from '../../models/ImageType';
import { HEADER } from './../../styles/variables/sizes';

interface StyleProps {
  isOpen: boolean;
  imageBackground?: ImageType;
}

const useHeaderStyles = makeStyles((theme) => ({
  root: ({ imageBackground }: StyleProps) => ({
    position: 'relative',
    background: theme.palette.common.white,
    backgroundImage: !!imageBackground ? getMagnoliaUrlImage(imageBackground) : 'none',
    backgroundSize: 'cover',

    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%'
    }
  }),
  toolbarContainer: {
    background: 'transparent',
    boxShadow: 'none'
  },
  header: {
    display: 'flex',
    position: 'relative',
    height: HEADER.height,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('xs')]: {
      height: HEADER.mobileHeight
    }
  },
  [theme.breakpoints.down('xs')]: {
    imageContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'flex-start',

      '& img': {
        width: '50%',
        padding: '% 0'
      }
    }
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.palette.primary.main
  },

  linkArea: ({ isOpen }: StyleProps) => ({
    listStyle: 'none',
    display: 'flex',
    position: 'fixed',
    flexDirection: 'column',
    width: '60%',
    height: '100%',
    marginTop: 0,
    top: HEADER.mobileHeight,
    '& a': {
      color: theme.palette.primary.main,
      display: 'flex',
      textDecoration: 'none',
      padding: 25
    },
    transform: isOpen ? 'translateX(150%)' : 'translateX(-93%)',
    transition: 'transform ease 0.5s',
    background: theme.palette.common.white,
    [theme.breakpoints.up('lg')]: {
      marginBottom: 0,
      flexDirection: 'row',
      position: 'relative',
      transform: 'inherit',
      width: '100%',
      background: 'none',
      height: 'auto',
      marginTop: 'initial',
      top: 'initial'
    }
  })
}));

export default useHeaderStyles;
